<span *ngIf="asOfDate">
  <span attr.aria-label="{{'COMMON.asOf' | translate}}">{{'COMMON.asOf' | translate}}</span>&#160;
  <span attr.aria-label="{{asOfDate}} {{'COMMON.etCap' | translate}}">{{ asOfDate }}&#160;
  <span *ngIf="showEtCap">{{'COMMON.etCap'|translate}}</span>
</span>